module.exports = __webpack_public_path__ + "static/media/p6_card3.7dda4383.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/intro/p6_card3.svg
// module id = 2534
// module chunks = 0